import FrameImageRepository from "./Repositories/FrameImageRepository";
import FrameImagePreloader from "./FrameImagePreloader.js";
import DetailEventHandler from "./EventHandlers/DetailEventHandler";
import ListEventHandler from "./EventHandlers/ListEventHandler";
import GeneralEventHandler from "./EventHandlers/GeneralEventHandler";

export default class Factory
{
    /**
     * @returns {FrameImageRepository}
     */
    static getFrameImageRepository() {
        let self = this;
        return new FrameImageRepository(
            self.getFrameImagePreloader(),
        );
    }
    /**
     * @returns {FrameImagePreloader}
     */
    static getFrameImagePreloader() {
        return new FrameImagePreloader();
    }
    /**
     * @returns {GeneralEventHandler}
     */
    static getGeneralEventHandler() {
        return new GeneralEventHandler();
    }
    /**
     * @returns {DetailEventHandler}
     */
    static getDetailEventHandler() {
        return new DetailEventHandler(jQuery(document).find('.single-product'));
    }
    /**
     * @returns {ListEventHandler}
     */
    static getListEventHandler() {
        return new ListEventHandler();
    }
}
